<!--
    描述：系统首页-项目列表
    时间：2020-03-16
    Created by ws
-->
<template>
	<div class="w-page-main home-index">
		<!-- 头部 -->
		<div class="w-page-header home-index-head">
			<div class="headone">
				<div class="flexone">
					<span class="name">项目总数</span>
					<span class="num">{{ProjectSum.projectSum}}</span>
				</div>
			</div>
			<div class="headone">
				<div class="flexone">
					<span class="name">造价阶段</span>
					<span class="num">{{ProjectSum.phaseSum}}</span>
				</div>
			</div>
			<div class="headone">
				<div class="flexone">
					<span class="name">跟踪审计</span>
					<span class="num">{{ProjectSum.trackSum}}</span>
				</div>
			</div>
			<div class="headone">
				<div class="flexone">
					<span class="name">分析结果</span>
					<span class="num">{{ProjectSum.analysisSum}}</span>
				</div>
			</div>
		</div>
		<div class="w-page-container home-index-container">
			<div class="home-index-content">
				<!-- 内容头部 -->
				<div class="content-head">
					<div class="content-select">
						<div class="content-select-change">
							<el-select v-model="place"
									   disabled
									   placeholder="请选择">
								<el-option v-for="item in placeList"
										   :key="item.value"
										   :label="item.label"
										   :value="item.value">
								</el-option>
							</el-select>

							<el-select v-model="years"
									   collapse-tags
									   clearable
									   @change="changeSelect"
									   value-key="id"
									   style="margin-left: 20px;"
									   placeholder="请选择日期">
								<el-option v-for="item in yearsList"
										   :value="item.label"
										   :key="item.value">{{ item.label }}
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="content-icon">
						<div class="icon-flex">
							<div class="flex"
								 :class="{activeBtn: showType === 'pie'}"
								 @click="changeShow('pie')">
								<span class="pict"><img src="../../assets/images/pie.png"
										 class="pie"
										 alt="饼状图"></span><span class="pie">饼状图</span>
							</div>
							<div class="flex"
								 :class="{activeBtn: showType === 'line'}"
								 @click="changeShow('line')">
								<span class="pict"><img src="../../assets/images/line.png"
										 class="line"
										 alt="柱状图"></span><span class="pie">柱状图</span>
							</div>
						</div>
					</div>
					<div class="content-radio">
						<template v-if="showType !== 'pie'">
							<el-radio-group v-model="radio"
											size="small"
											@change="changeRadio">
								<el-radio label="1">按地区</el-radio>
								<el-radio label="2">按类型</el-radio>
								<el-radio label="3">按月份</el-radio>
							</el-radio-group>
						</template>
					</div>
				</div>
				<!-- 内容echart -->
				<div class="echart-container"
					 v-show="showType==='pie'">
					<div id="first"></div>
					<div id="two"></div>
					<div id="three"></div>
					<div id="four"></div>
				</div>
				<div class="echart-container"
					 v-if="showType==='line'">
					<div id="five"></div>
				</div>
			</div>
		</div>
		<!-- 大图弹窗 -->
		<div class="enlarge-container"
			 v-if="showBigger">
			<h3 class="enlarge-title">大图查看<em class="el-icon-close"
					@click="showBigger = false"></em></h3>
			<div id="enlarge_chart"></div>
		</div>
		<div class="enlarge-wrap"
			 v-if="showBigger"></div>
	</div>
</template>

<script>
import { selectProjectSum, pieChart, barChart } from '@/api/modules/home'
export default {
	name: 'Home',
	components: {},
	data() {
		return {
			showBigger: false,
			showType: 'pie',
			yearsList: [
				{
					value: '1',
					label: (new Date().getFullYear() - 2)+'年'
				},
				{
					value: '2',
					label: (new Date().getFullYear() - 1)+'年'
				},
				{
					value: '3',
					label: (new Date().getFullYear())+'年'
				}
			],
			placeList: [
				{
					value: '1',
					label: '合肥市'
				}
			],
			place: '1',
			years: '',
			radio: '1',
			echartarr: [
				{ name: '合肥市地区占比' },
				{ name: '当年月份数量占比' },
				{ name: '项目类型占比' },
				{ name: '当年月份金额占比' }
			],
			ProjectSum: {
				analysisSum: 0, // ---分析结果
				phaseSum: 0, //---造价阶段
				projectSum: 0, //  ---项目总数
				trackSum: 0 //   ---跟踪审计
			},
			pieData1: [],
			pieData2: [],
			pieData3: [],
			pieData4: [],
			cityNames: [],
			projectTypeNames: [],
			num: [],
			zhanBi: [],
			radio3Num: [],
			radioMoney: [],
		}
	},
	created() {
		this.years = new Date().getFullYear()+'年'
		this.$nextTick(() => {
			this.getPieChart(this.years)
			setTimeout(() => {
				this.getdom('first')
				this.getdom('two')
				this.getdom('three')
				this.getdom('four')
				this.getdom('five')
			}, 300)
			this.getHeadTract()
		})
	},
	mounted() {
		this.$nextTick(() => {})
	},
	methods: {
		//头部数据
		getHeadTract() {
			selectProjectSum({}).then(res => {
				if (res.code === 0) {
					this.ProjectSum = res.data
				}
			})
		},
		//点击查看大图
		changeEnlarge(type) {
			this.showBigger = true

			setTimeout(() => {
				let _item = document.getElementById('enlarge_chart')
				if (_item) {
					let _enlargeChart = this.$echarts.init(_item)
					_enlargeChart.clear()

					this.initBigChart(_enlargeChart, type)

					// 窗口移动事件
					window.onresize = () => {
						_enlargeChart.resize()
					}
				}
			}, 300)
		},

		//切换事件
		changeShow(type) {
			this.showType = type
			if (this.showType === 'line') {
				this.$nextTick(() => {
					this.getdom('five')
				})
			} else {
				this.$nextTick(() => {
					this.getPieChart(this.years)
					this.getdom('first')
					this.getdom('two')
					this.getdom('three')
					this.getdom('four')
				})
			}
		},

		//获取id
		getdom(type) {
			let _five = document.getElementById(type)
			if (_five) {
				let _fiveChart = this.$echarts.init(_five)
				_fiveChart.clear()
				type === 'five'
					? this.getCharts(_fiveChart, type, 'bar')
					: this.getCharts(_fiveChart, type, 'pie')

				// 窗口移动事件
				window.onresize = () => {
					_fiveChart.resize()
				}
				setTimeout(() => {
					_fiveChart.resize()
				}, 300)
			}
		},

		//点击大图
		initBigChart(domid, type) {
			let option = {}
			let navTitle = '',
				resetData = [],
				colorList = [
					'#399be1',
					'#36cbcb',
					'#4ecb73',
					'#fbd437',
					'#da6fad',
					'#88b4ca',
					'#d18061',
					'#65c5bd',
					'#4fcce7',
					'#d16361',
					'#b38661',
					'#40E0D0',
					'#F0E68C',
					'#F4A460',
					'#6495ED',
					'#7B68EE'
				]
			switch (type) {
				case 'first':
					navTitle = this.echartarr[0].name
					resetData = this.pieData1
					break
				case 'two':
					navTitle = this.echartarr[1].name
					resetData = this.pieData2
					break
				case 'three':
					navTitle = this.echartarr[2].name
					resetData = this.pieData3
					break

				default:
					navTitle = this.echartarr[3].name
					resetData = this.pieData4
					break
			}
			option = {
				title: {
					text: navTitle,
					left: 'center',
					top: '48%',
					textStyle: {
						color: '#031f2d',
						fontSize: 14,
						align: 'center'
					}
				},
				toolbox: {
					feature: {
						saveAsImage: {
							title: '保存为png',
							pixelRatio: 2
						}
					},
					top: 20
				},
				tooltip: {
					trigger: 'item',
					formatter: function(params) {
						return `${params.name}\n占比: ${params.value}%`
					}
				},
				legend: {
					bottom: 10,
					left: 'center',
					textStyle: {
						color: '#666',
						fontSize: 12
					},
					itemHeight: 9,
					itemWidth: 15,
					data: resetData
				},
				series: [
					{
						type: 'pie',
						radius: '50%',
						center: ['50%', '50%'],
						hoverAnimation: false,
						label: {
							normal: {
								show: true,
								formatter: e => {
									return `${e.name}\n占比: ${e.value}%`
								},
								textStyle: {
									fontSize: 12
								},
								position: 'outside'
							},
							emphasis: {
								show: true
							}
						},
						itemStyle: {
							normal: {
								// 饼图块
								color: function(params) {
									return colorList[params.dataIndex]
								}
							}
						},
						data: resetData
					}
				]
			}
			domid.setOption(option)
		},

		//饼状图
		getCharts(capid, domid, type) {
			// var myChart = this.$echarts.init(document.getElementById(domid))
			let option = {}
			let navTitle = '',
				resetData = [],
				colorList = [
					'#399be1',
					'#36cbcb',
					'#4ecb73',
					'#fbd437',
					'#da6fad',
					'#88b4ca',
					'#d18061',
					'#65c5bd',
					'#4fcce7',
					'#d16361',
					'#b38661',
					'#40E0D0',
					'#F0E68C',
					'#F4A460',
					'#6495ED',
					'#7B68EE'
				]
			switch (domid) {
				case 'first':
					navTitle = this.echartarr[0].name
					resetData = this.pieData1
					break
				case 'two':
					navTitle = this.echartarr[1].name
					resetData = this.pieData2
					break
				case 'three':
					navTitle = this.echartarr[2].name
					resetData = this.pieData3
					break

				default:
					navTitle = this.echartarr[3].name
					resetData = this.pieData4
					break
			}
			if (type === 'pie') {
				option = {
					title: {
						text: navTitle,
						left: 'center',
						top: '48%',
						textStyle: {
							color: '#031f2d',
							fontSize: 14,
							align: 'center'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: function(params) {
							return `${params.name}\n占比: ${params.value}%`
						}
					},
					toolbox: {
						feature: {
							myTool1: {
								show: true,
								z: '999',
								left: 'center',
								title: '查看大图',
								icon:
									'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
								onclick: () => {
									// 展示大图
									this.changeEnlarge(domid)
								}
							}
						},
						top: 18,
						right: 20
					},
					legend: {
						bottom: 10,
						left: 'center',
						textStyle: {
							color: '#666',
							fontSize: 12
						},
						itemHeight: 9,
						itemWidth: 15,
						data: resetData
					},
					series: [
						{
							type: 'pie',
							radius: '50%',
							center: ['50%', '50%'],
							hoverAnimation: false,
							label: {
								normal: {
									show: true,
									formatter: e => {
										return `${e.name}\n占比: ${e.value}%`
									},
									textStyle: {
										fontSize: 12
									},
									position: 'outside'
								},
								emphasis: {
									show: true
								}
							},
							itemStyle: {
								normal: {
									// 饼图块
									color: function(params) {
										return colorList[params.dataIndex]
									}
								}
							},
							data: resetData
						}
					]
				}
			} else if (type === 'bar' || this.radio) {
				let that = this
				barChart({
					year: this.years.split('年').join(''),
					type: +this.radio
				}).then(res => {
					if (res.code === 0) {
						that.cityNames = res.data.cityNames
						that.num = res.data.num
						that.projectTypeNames = res.data.projectTypeNames
						that.zhanBi = res.data.zhanBi
						if (this.radio === '3') {
							that.radio3Num = res.data[0].data
							that.radioMoney = res.data[1].data
						}
					} else {
						this.$Message.error(res.msg)
					}
					if (this.radio !== '3') {
						this.$nextTick(() => {
							option = {
								tooltip: {
									trigger: 'axis',
									axisPointer: {
										type: 'cross',
										crossStyle: {
											color: '#999'
										}
									}
								},
								toolbox: {
									feature: {
										saveAsImage: { show: true }
									}
								},
								color: ['#199ed8', '#00cccc'],
								grid: [
									{
										x: '7%',
										y: '7%',
										height: '45%',
										left: '10%'
									},
									//1水位流量
									{
										x: '7%',
										y2: '7%',
										height: '35%',
										left: '10%',
										bottom: '13%'
									}
								],
								legend: {
									left: 'center',
									bottom: 10,
									itemHeight: 9,
									itemWidth: 15,
									data: ['数量', '占比']
								},
								xAxis: [
									{
										axisLine: {
											lineStyle: {
												color: '#ccc'
											}
										},
										axisLabel: {
											textStyle: {
												color: '#606266',
												fontSize: '14'
											}
										},
										show: false, //隐藏了x轴
										type: 'category',
										gridIndex: 0, //对应前面grid的索引位置（第一个）
										axisTick: {
											alignWithLabel: true
										},
										offset: 20,
										data:
											+this.radio === 1
												? that.cityNames
												: this.projectTypeNames
									},
									{
										axisLine: {
											lineStyle: {
												color: '#ccc'
											}
										},
										axisLabel: {
											textStyle: {
												color: '#606266',
												fontSize: '14'
											}
										},
										type: 'category',
										gridIndex: 1, //对应前面grid的索引位置（第二个）
										axisTick: {
											alignWithLabel: true
										},
										offset: 20,
										data:
											+this.radio === 1
												? that.cityNames
												: this.projectTypeNames
									}
								],

								yAxis: [
									{
										name: '占比（%）',
										inverse: true,
										type: 'value',
										axisLine: { show: false }, //轴线不显示
										axisTick: { show: false }, //
										gridIndex: 1, //对应前面grid的索引位置（第二个）
										splitLine: {
											show: true,
											lineStyle: {
												type: 'dashed'
											}
										},
										axisLabel: {
											textStyle: {
												fontSize: '14'
											}
										}
									},
									{
										inverse: true,
										type: 'value',
										axisLine: { show: false }, //轴线不显示
										axisTick: { show: false }, //
										gridIndex: 1,
										splitLine: { show: false },
										position: 'left',
										axisLabel: {
											formatter: '{value}'
										}
									},
									{
										name: '数量（个）',
										inverse: false,
										axisLine: { show: false }, //轴线不显示
										axisTick: { show: false }, //
										type: 'value',
										gridIndex: 0,
										splitLine: {
											show: true,
											lineStyle: {
												type: 'dashed'
											}
										},
										axisLabel: {
											textStyle: {
												fontSize: '14'
											}
										}
									},
									{
										inverse: true,
										type: 'value',
										gridIndex: 0,
										splitLine: { show: false },
										axisLine: { show: false }, //轴线不显示
										axisTick: { show: false }, //
										position: 'left'
									}
								],

								series: [
									{
										name: '数量',
										type: 'bar',
										barWidth: 30,
										xAxisIndex: 0,
										yAxisIndex: 2,
										data: that.num,
										label: {
											show: true,
											fontSize: 14,
											position: 'top',
											color: '#199ed8',
											formatter: params => {
												return '' + params.value + '个'
											}
										}
									},

									{
										name: '占比',
										barWidth: 30,
										type: 'bar',
										xAxisIndex: 1,
										yAxisIndex: 0,
										data: that.zhanBi,
										label: {
											show: true,
											fontSize: 14,
											position: 'bottom',
											color: '#00cccc',
											formatter: params => {
												return params.value + '%'
											}
										}
									}
								]
							}
							// 为echarts对象加载数据
							if (
								option &&
								typeof option === 'object' &&
								!this.isEmpatyData
							) {
								capid.setOption(option, true)
								window.addEventListener('resize', () => {
									capid.resize()
								})
							}
						})
					} else {
						this.$nextTick(() => {
							let month = [
								'一月',
								'二月',
								'三月',
								'四月',
								'五月',
								'六月',
								'七月',
								'八月',
								'九月',
								'十月',
								'十一月',
								'十二月'
							]
							option = {
								grid: {
									left: '10%',
									right: '10%'
								},
								tooltip: {
									trigger: 'item'
								},
								legend: {
									data: ['数量', '金额'],
									left: 'center',
									bottom: 10,
									itemHeight: 9,
									itemWidth: 15
								},
								xAxis: [
									{
										type: 'category',
										axisLine: {
											lineStyle: {
												color: '#ccc'
											}
										},
										axisLabel: {
											textStyle: {
												color: '#606266',
												fontSize: '14'
											}
										},
										data: month //x轴使用动态数据
									}
								],
								yAxis: [
									//第一个Y轴配置
									{
										name: '数量（个）',
										type: 'value',
										min: 0,
										splitLine: {
											show: true,
											lineStyle: {
												type: 'dashed'
											}
										},
										splitNumber: 5,
										axisLine: {
											show: false
										},
										axisTick: {
											show: false
										},
										axisLabel: {
											fontSize: 14
											// color: '#65C6E7'
										}
									},
									{
										name: '金额（万元）',
										type: 'value',
										min: 0,
										max: 100,
										splitLine: {
											show: false
										},
										axisLine: {
											show: false
										},
										axisTick: {
											show: false
										},
										axisLabel: {
											fontSize: 14
											// color: '#65C6E7'
										}
									}
								],
								series: [
									{
										name: '数量',
										type: 'bar',
										barGap: '1%',
										itemStyle: {
											normal: {
												color: '#199ed8' //月节能量柱状图颜色
											}
										},
										data: that.radio3Num //第一个Y轴使用动态数据
									},
									{
										name: '金额',
										type: 'bar',
										yAxisIndex: 1, //选用那个坐标轴显示，默认为0	 	//第二个Y轴使用动态数据
										itemStyle: {
											normal: {
												color: '#00cccc' //节能百分比柱状图颜色
											}
										},
										data: that.radioMoney
									}
								]
							}
							// 为echarts对象加载数据
							if (
								option &&
								typeof option === 'object' &&
								!this.isEmpatyData
							) {
								capid.setOption(option, true)
								window.addEventListener('resize', () => {
									capid.resize()
								})
							}
						})
					}
				})
			}
			// 为echarts对象加载数据
			if (option && typeof option === 'object' && !this.isEmpatyData) {
				capid.setOption(option, true)
				window.addEventListener('resize', () => {
					capid.resize()
				})
			}
		},

		//select切换
		changeSelect(item) {
			if (this.showType === 'pie') {
				this.getPieChart(item)
			} else {
				this.getdom('five')
			}
		},

		//radio切换
		changeRadio() {
			let _five = document.getElementById('five')
			let _fiveChart = this.$echarts.init(_five)
			_fiveChart.clear()
			this.getCharts(_fiveChart, 'bar')
		},

		//获取饼状图数据
		getPieChart(value) {
			pieChart({
				year: value.split('年').join('')
			}).then(res => {
				if (res.code === 0) {
					this.pieData1 = res.data.param1
					this.pieData2 = res.data.param3
					this.pieData3 = res.data.param5
					this.pieData4 = res.data.param7
				} else {
					this.$Message.error()
				}
			})
		},
	},
	watch: {
		pieData1: {
			handler(value) {
				this.pieData1 = value
				this.getdom('first')
			},
			deep: true
		},
		pieData2: {
			handler(value) {
				this.pieData2 = value
				this.getdom('two')
			},
			deep: true
		},
		pieData3: {
			handler(value) {
				this.pieData3 = value
				this.getdom('three')
			},
			deep: true
		},
		pieData4: {
			handler(value) {
				this.pieData4 = value
				this.getdom('four')
			},
			deep: true
		}
	}
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>

